// extracted by mini-css-extract-plugin
module.exports = {"search":"style_search__1P1Jo"};